import React from "react";
import ProductsPipelinePage from "./ProductsPipe";
import ResearchPublicationsBox from "./Research";




function Productpages() {
  return (
 <>
      <ProductsPipelinePage/>
       <ResearchPublicationsBox/>
 </>

  );
}

export default Productpages;
